const matchWith = {
    strict: true,
    namespaced: true,
    state: {
        products: [],
        url: null
    },
    mutations: {
        setProducts(state, payload) { 
            state.products = payload;
        },
        setUrl(state, payload) {
            state.url = payload;
        }
    },
    
    actions: {
        // state, commit, dispatch, rootState, rootGetters
        setData(context, payload, dispatch, rootState, rootGetters) {
            const products = payload ? payload.products : [];
            const url = payload ? payload.url : null;
            context.commit('setProducts', products);
            context.commit('setUrl', url);
        },
    },
    getters: {
        products: state => state.products,
        url: state => state.url,
    },
};

export default matchWith;